import { AUDIO_NODE_CONNECTIONS_STORE } from '../globals';
import { getValueForKey } from './get-value-for-key';
export const getAudioNodeConnections = (audioNode) => {
    return getValueForKey(AUDIO_NODE_CONNECTIONS_STORE, audioNode);
};
//# sourceMappingURL=/build/es2018/helpers/get-audio-node-connections.js.map